import '../styles/index.scss'
import * as React from 'react'
import { useEffect } from 'react'
import { graphql} from 'gatsby'
import Layout from '../components/layout'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import MetaTags from '../components/metatags'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { INLINES, BLOCKS, MARKS } from '@contentful/rich-text-types'
import AOS from 'aos';
import 'aos/dist/aos.css';


const IndexPage = ({ data }) => {

	useEffect(() => {
        AOS.init({
            delay:100,
            duration : 650,
            easing:'ease'
        });
      }, []);

	const { logo } = data
	const { pageData } = data
	const { metaTitle, metaDescription, intro, cards } = pageData

	return (
		<Layout>
			<MetaTags {...[metaTitle, metaDescription.metaDescription,"",'/',logo.file.url]} />
			<Container id="homepage">

				<Row className='mt-5 mb-3' data-aos="fade-in">
					<Col>
					
						{renderRichText(intro, options)}
						
					</Col>
				</Row>

				<Row className="">
					
						
							{cards.map((card, i, arr) => {
                				const { text } = card
								if (arr.length - 1 === i) {
									return (
										<Col xs={12} sm={6} lg={{span:4,offset:4}} className='p-3 bucket' data-aos="fade-in">
											<a href={card.link} target="_blank" rel="noreferrer">
												<GatsbyImage className="mx-auto" image={getImage(card.image)} />
											</a>
											
											{renderRichText(text, options)}
											
										</Col>
									)
								} else {
									return (
										<Col xs={12} sm={6} lg={4} className='p-3 bucket'data-aos="fade-in">
											<a href={card.link} target="_blank" rel="noreferrer">
												<GatsbyImage className="mx-auto" image={getImage(card.image)} />
											</a>
											
											{renderRichText(text, options)}
											
										</Col>
									)
								}
							})}
						
				
				</Row>
			</Container>
		</Layout>
	)
}

const options = {
	renderMark: {
	  [MARKS.BOLD]: (text) => <b className="font-bold">{text}</b>,
	},
	renderNode: {
	  [INLINES.HYPERLINK]: (node, children) => {
		const { uri } = node.data
		return (
		  <a href={uri} target="_blank" rel="noreferrer" className="underline">
			{children}
		  </a>
		)
	  },
	  [BLOCKS.HEADING_2]: (node, children) => {
		return <h2>{children}</h2>
	  },
	},
  }


export default IndexPage

// use localhost:8000/__graphql 'allContenfulHomepage' to find the contentful_id of the homepage content you want
export const query = graphql`
	query {
		logo: contentfulAsset(contentful_id: {eq: "7tsXZSBxJtxSSx6QvPjID4"}) {
			file{
				url
			}
		}
		pageData: contentfulImbHomepage(contentful_id: {eq: "5yQxhcHZJuRDV3Sizx9a4F"}) {
			metaTitle
			metaDescription {
				metaDescription
			}
			intro{
				raw
			}
			cards {
				text{
					raw
				}
        		link
				image {
					gatsbyImageData
				}
			}
		}
	}
`